import type { CartMap, Product, RecommendationItem } from "../../types";
import QuantityInput from "../catalog/QuantityInput";
import {
  resolveMinQuantitySimple,
  resolveStep,
} from "../../utils/productQuantity";
import {
  getRecommendationCartValues,
  getRecommendationPriceLabel,
  getRecommendationTextValues,
} from "../../utils/recommendationItem";

interface RecommendedProductListItemProps {
  item: RecommendationItem;
  cart?: CartMap;
  onQuantityChange?: (product: Product, value: number) => void;
  baseMinQuantity?: number;
}

const RecommendedProductListItem = ({
  item,
  cart = {},
  onQuantityChange,
  baseMinQuantity = 0,
}: RecommendedProductListItemProps) => {
  const product = item.product;
  const { description, availabilityLabel } = getRecommendationTextValues(item);
  const priceLabel = getRecommendationPriceLabel(item);
  const { quantity, canEdit } = getRecommendationCartValues({
    product,
    cart,
    onQuantityChange,
  });

  return (
    <li className="recommended-item">
      <div className="recommended-main">
        <span className="recommended-name">{item.name}</span>
        {priceLabel && <span className="recommended-meta">{priceLabel}</span>}
        <p className="recommended-description">{description}</p>
        {availabilityLabel && (
          <p className="recommended-availability">{availabilityLabel}</p>
        )}
      </div>
      {canEdit && product && onQuantityChange && (
        <div className="recommended-quantity">
          <QuantityInput
            value={quantity}
            onChange={(value) => onQuantityChange(product, value)}
            minQuantity={resolveMinQuantitySimple(product, baseMinQuantity)}
            step={resolveStep(product)}
          />
        </div>
      )}
    </li>
  );
};

export default RecommendedProductListItem;
